
<template>
  <b-tabs v-model="activeTab"  justified pills>
    <b-tab title="Auto-évaluation" active>
      <b-card no-body>
        <b-card-body>
          <b-row>
            <!-- Options de validation -->
            <b-col md="2" sm="4" class="my-1">
              <b-form-group class="mb-0">
                <label class="d-inline-block text-sm-left mr-50">Nbr page</label>
                <b-form-select id="perPageSelect" v-model="perPageAuto" size="sm" :options="pageOptionsAuto" class="w-50" />
              </b-form-group>
            </b-col>

            <b-col md="10" class="my-1 justify-content-end">
              <b-form-group label="Filtrer" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
                <b-input-group size="sm">
                  <b-form-input id="filterInput" v-model="filterAuto" type="search" placeholder="Rechercher..." @input="fetchUsers" />
                  <b-input-group-append>
                    <b-button :disabled="!filterAuto" @click="filterAuto = ''">Effacer</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-table
                  striped
                  hover
                  responsive
                  :items="usersAuto"
                  :fields="tableColumnsAuto"
                  :sort-by.sync="sortByAuto"
                  :sort-desc.sync="sortDescAuto"
                  :sort-direction="sortDirectionAuto"

              >
                <template #cell(user)="data">
                  <b-media vertical-align="center">
                    <template #aside>
                      <b-avatar size="40" variant="light-primary" class="badge-minimal" badge-variant="success">
                        {{ getUserInitials(data.item) }}
                      </b-avatar>
                    </template>
                    <span class="font-weight-bold d-block text-nowrap">
                    {{ data.item.lastName + ' ' + data.item.firstName }}
                  </span>
                    <small class="text-muted">{{ data.item.mail }}</small>
                  </b-media>
                </template>

                <template #cell(fonction)="data">
                <span v-if="data.item.fonction" class="font-weight-bold d-block text-nowrap">
                  {{ data.item.fonction }}
                </span>

                </template>
                <template #cell(services)="data">
                <span v-if="data.item.services" class="font-weight-bold d-block text-nowrap">
                  {{ data.item.services.name }}
                </span>
                  <small v-if="data.item.directions" class="text-muted">
                    {{ data.item.directions.name }}
                  </small>
                </template>

              </b-table>
            </b-col>
          </b-row>
        </b-card-body>
        <b-col cols="12">
          <b-pagination
              v-model="currentPageAuto"
              :total-rows="totalRowsAuto"
              :per-page="perPageAuto"
              align="center"
              size="sm"
              class="my-1"
          />
          <p>Total: {{ totalRowsAuto }} | Par page: {{ perPageAuto }}</p>
        </b-col>
      </b-card>
    </b-tab>
    <b-tab title="Évaluation">
      <b-card no-body>
        <b-card-body>
          <b-row>
            <!-- Options de validation -->
            <b-col md="2" sm="4" class="my-1">
              <b-form-group class="mb-0">
                <label class="d-inline-block text-sm-left mr-50">Nbr page</label>
                <b-form-select id="perPageSelect" v-model="perPageEvaluation" size="sm" :options="pageOptionsEvaluation" class="w-50" />
              </b-form-group>
            </b-col>

            <b-col md="10" class="my-1 justify-content-end">
              <b-form-group label="Filtrer" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
                <b-input-group size="sm">
                  <b-form-input id="filterInput" v-model="filterEvaluation" type="search" placeholder="Rechercher..." @input="fetchUsers" />
                  <b-input-group-append>
                    <b-button :disabled="!filterEvaluation" @click="filterEvaluation = ''">Effacer</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-table
                  striped
                  hover
                  responsive
                  :items="usersEvaluation"
                  :fields="tableColumnsEvaluation"
                  :sort-by.sync="sortByEvaluation"
                  :sort-desc.sync="sortDescEvaluation"
                  :sort-direction="sortDirectionEvaluation"

              >
                <template #cell(user)="data">
                  <b-media vertical-align="center">
                    <template #aside>
                      <b-avatar size="40" variant="light-primary" class="badge-minimal" badge-variant="success">
                        {{ getUserInitials(data.item) }}
                      </b-avatar>
                    </template>
                    <span class="font-weight-bold d-block text-nowrap">
                    {{ data.item.lastName + ' ' + data.item.firstName }}
                  </span>
                    <small class="text-muted">{{ data.item.mail }}</small>
                  </b-media>
                </template>

                <template #cell(fonction)="data">
                <span v-if="data.item.fonction" class="font-weight-bold d-block text-nowrap">
                  {{ data.item.fonction }}
                </span>

                </template>
                <template #cell(services)="data">
                <span v-if="data.item.services" class="font-weight-bold d-block text-nowrap">
                  {{ data.item.services.name }}
                </span>
                  <small v-if="data.item.directions" class="text-muted">
                    {{ data.item.directions.name }}
                  </small>
                </template>

              </b-table>
            </b-col>
          </b-row>
        </b-card-body>
        <b-col cols="12">
          <b-pagination
              v-model="currentPageEvaluation"
              :total-rows="totalRowsEvaluation"
              :per-page="perPageEvaluation"
              align="center"
              size="sm"
              class="my-1"
          />
          <p>Total: {{ totalRowsEvaluation }} | Par page: {{ perPageEvaluation }}</p>
        </b-col>
      </b-card>
    </b-tab>

  </b-tabs>
</template>

<script>
import {
  BTabs,
  BTab,
  BInputGroupAppend,
  BInputGroup,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BPagination, BTable, BButton, BFormSelect, BAvatar
} from 'bootstrap-vue'
import {getUsersWithoutEvaluation, getUsersWithoutObjective} from "@/services/UserService";
export default {
  components: {
    BAvatar,
    BFormSelect,
    BButton,
    BTable,
    BPagination,
    BFormInput,
    BFormGroup,
    BCol,
    BRow,
    BInputGroup,
    BInputGroupAppend,
    BTabs,
    BTab,
  },
  data() {
    return {
      perPageAuto: 10,
      pageOptionsAuto: [3, 5, 10, 25, 50, 100, 200],
      totalRowsAuto: 0, // Initialisé à 0
      currentPageAuto: 1,
      sortByAuto: '',
      sortDescAuto: false,
      sortDirectionAuto: 'asc',
      filterAuto: null,
      filterOnAuto: ['user', 'fonction', 'services'],
      usersAuto: [],
      usersEvaluation: [],
      perPageEvaluation: 10,
      pageOptionsEvaluation: [3, 5, 10, 25, 50, 100, 200],
      totalRowsEvaluation: 0, // Initialisé à 0
      currentPageEvaluation: 1,
      sortByEvaluation: '',
      sortDescEvaluation: false,
      sortDirectionEvaluation: 'asc',
      filterEvaluation: null,
      filterOnEvaluation: ['user', 'fonction', 'services'],
      configs: [], // Pour stocker les configurations
      activeTab: 0,

    };
  },

  computed: {

    tableColumnsAuto() {
      return [
        { key: 'user', label: 'Nom Prénom(s)', sortable: true },
        { key: 'fonction', label: 'Fonction', sortable: true },
        { key: 'services', label: 'Services', sortable: true },
      ];
    },
    tableColumnsEvaluation() {
      return [
        { key: 'user', label: 'Nom Prénom(s)', sortable: true },
        { key: 'fonction', label: 'Fonction', sortable: true },
        { key: 'services', label: 'Services', sortable: true },
      ];
    },
  },
  methods: {

    getUserInitials(user) {
      const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
      const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
      return `${lastInitial}${firstInitial}`
    },
    async fetchUsers() {
      const year = this.$route.params.year;
      if (!year) {
        console.error("Year undefined");
        return;
      }

      if(this.activeTab === 0){
        getUsersWithoutEvaluation(this.currentPageAuto - 1, this.perPageAuto, Number(year), this.filterAuto,true).then(response => {
              this.usersAuto = response.users;
              this.totalRowsAuto = response.countUser;

            }
        )
      }else{
        getUsersWithoutEvaluation(this.currentPageEvaluation - 1, this.perPageEvaluation, Number(year), this.filterEvaluation,false).then(response => {
              this.usersEvaluation = response.users;
              this.totalRowsEvaluation = response.countUser;

            }
        )
      }


    },

  },
  watch: {
    activeTab(newVal, oldVal) {

      if (newVal !== oldVal) this.fetchUsers();
    },
    filterAuto(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUsers();
    },
    filterEvaluation(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUsers();
    },
    currentPageAuto(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUsers();
    },
    perPageAuto(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUsers();
    },
    currentPageEvaluation(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUsers();
    },
    perPageEvaluation(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUsers();
    },
  },
  async mounted() {
    await this.fetchUsers();
  },
}
</script>
 